import { useEffect, useLayoutEffect, useRef } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

const KEY = "miahma-scroll-pos";
const read = (): Record<string, number> => { try { return JSON.parse(sessionStorage.getItem(KEY) || "{}"); } catch { return {}; } };

/** Topo em navegação nova; ao voltar/avançar (POP), restaura a rolagem salva daquela entrada. */
export const ScrollToTop = () => {
  const location = useLocation();
  const navType = useNavigationType();

  // Guarda a rolagem da entrada atual enquanto o usuário rola.
  useEffect(() => {
    let t = 0;
    const save = () => {
      clearTimeout(t);
      t = window.setTimeout(() => {
        const m = read(); m[location.key] = window.scrollY;
        const keys = Object.keys(m); if (keys.length > 60) delete m[keys[0]];
        try { sessionStorage.setItem(KEY, JSON.stringify(m)); } catch { /* sem armazenamento */ }
      }, 120);
    };
    window.addEventListener("scroll", save, { passive: true });
    return () => { clearTimeout(t); window.removeEventListener("scroll", save); };
  }, [location.key]);

  const prevPath = useRef<string | null>(null);
  useLayoutEffect(() => {
    const samePath = prevPath.current === location.pathname;
    prevPath.current = location.pathname;
    if (navType !== "POP" && samePath) return; // filtros/parâmetros na mesma página não rolam
    const target = navType === "POP" ? read()[location.key] : undefined;
    if (!target) { window.scrollTo({ top: 0, left: 0, behavior: "instant" }); return; }
    // A grade carrega aos poucos: tenta até a página ter altura suficiente (máx. ~2,5s).
    let tries = 0; let t = 0;
    const attempt = () => {
      window.scrollTo({ top: target, left: 0, behavior: "instant" });
      if (Math.abs(window.scrollY - target) > 4 && tries++ < 25) t = window.setTimeout(attempt, 100);
    };
    attempt();
    return () => clearTimeout(t);
  }, [location.key]); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
};
